export default __webpack_public_path__ + "images/70d04237076fecdb68690c3520ede78b-swimmingandwatersports.webp";